<script setup>
import { computed } from "vue";
import { useWindowScroll } from "@vueuse/core";

const { y } = useWindowScroll();

const isVisible = computed(() => y.value > 100);

const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
};
</script>
<template>
  <transition name="fade">
    <p v-if="isVisible" class="jump-pagetop" id="jump-pagetop">
      <a href="#" @click="scrollToTop">scrollToTop</a>
    </p>
  </transition>
</template>

<style scoped>
.scroll-to-top {
  position: fixed;
  bottom: 20px;
  right: 20px;
  background-color: #666;
  color: #fff;
  padding: 10px 15px;
  border-radius: 5px;
  cursor: pointer;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
@media (max-width: 768px) {
    .jump-pagetop{
        margin-bottom: 0;
        bottom:0;
    }
}
</style>
